import useSWR, { mutate } from 'swr';
import { useState, useEffect } from 'react';

import { fetcher, endpoints } from 'src/lib/axios';

import { toast } from 'src/components/snackbar';

const jobSwrOptions = { dedupingInterval: 10_000 } as const;

export function useJobPostingDetails(jobId: string | null | undefined) {
  const key = jobId ? endpoints.jobs.details(jobId) : null;
  return useSWR(key, fetcher, jobSwrOptions);
}

export function useJobWorkflowStages(jobId: string | null | undefined) {
  const key = jobId ? endpoints.jobs.workflowStages(jobId) : null;
  return useSWR(key, fetcher, jobSwrOptions);
}

export function useJobWorkflowStageCounts(jobId: string | null | undefined) {
  const key = jobId ? endpoints.jobs.stageCounts(jobId) : null;
  return useSWR(key, fetcher, jobSwrOptions);
}

export function revalidateJobWorkflowStageCounts(jobId: string) {
  return mutate(endpoints.jobs.stageCounts(jobId));
}

export function useJobWorkflowDetails(jobId: string | null | undefined) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!jobId) {
      setReady(false);
      return undefined;
    }

    const idleCallback = window.requestIdleCallback || ((fn: () => void) => setTimeout(fn, 200));
    const idleId = idleCallback(() => setReady(true), { timeout: 5000 });

    return () => {
      if ('cancelIdleCallback' in window) {
        window.cancelIdleCallback(idleId);
      } else {
        clearTimeout(idleId as unknown as number);
      }
    };
  }, [jobId]);

  const key = ready && jobId ? endpoints.job_workflows.get(jobId) : null;

  return useSWR(key, fetcher, {
    ...jobSwrOptions,
    revalidateOnFocus: false,
    onError: () => toast.error('Failed', { description: 'Error fetching workflow details' }),
  });
}
